import { createFileRoute } from '@tanstack/react-router'
import { MyCommissionPage } from '../../../../features/commissions/mine-page'

export const Route = createFileRoute('/_app/commissions/mine/')({
  component: MyCommissionPage,
})
